import React from 'react';

const StepperContext = React.createContext([]);

const StepperProvider = StepperContext.Provider;
const StepperConsumer = StepperContext.Consumer;

export { StepperProvider, StepperConsumer };
